import {
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Skeleton,
} from '@mui/material';
import { usePartyManager } from './PartyManagerContext';
import {
  POSSIBLE_SOURCES,
  EDIT_SOURCE,
  CODEMETA_SOURCE,
  SALUTATIONS,
} from './partyManagerUtils';

const SalutationField = ({ label }) => {
  const {
    partyData,
    handleFieldChange,
    handleCycleSource,
    getAvailableSources,
    isPartyManagerLoading,
  } = usePartyManager();

  const fieldKey = 'salutation';
  const fieldState = partyData[fieldKey];

  if (!fieldState) {
    return null;
  }

  const availableSources = getAvailableSources(fieldKey);
  const displayValue =
    fieldState.selected === 'edit'
      ? fieldState.edit
      : fieldState[fieldState.selected];

  const getButtonIcon = () => {
    const selectedSource = fieldState.selected;
    if (selectedSource === 'edit') return EDIT_SOURCE.icon;
    if (selectedSource === 'codemeta') {
      return (
        <img
          src={CODEMETA_SOURCE.icon}
          alt={CODEMETA_SOURCE.name}
          style={{ width: '24px', height: '24px' }}
        />
      );
    }
    const sourceInfo = POSSIBLE_SOURCES[selectedSource];
    if (sourceInfo?.icon) {
      return (
        <img
          src={sourceInfo.icon}
          alt={sourceInfo.name}
          style={{ width: '24px', height: '24px' }}
        />
      );
    }
    return '?';
  };

  const isOrganization = partyData.partyType === 'ORGANIZATION';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {isPartyManagerLoading ? (
        <Skeleton variant="rounded" width="100%" height={40} />
      ) : (
        <>
          <FormControl size="small" sx={{ flex: 1 }}>
            <InputLabel id="salutation-label">{label}</InputLabel>
            <Select
              labelId="salutation-label"
              label={label}
              id="salutation-select"
              value={displayValue}
              onChange={(event) =>
                handleFieldChange(fieldKey, event.target.value)
              }
            >
              {SALUTATIONS.filter((item) =>
                isOrganization
                  ? item.value === 'COMPANY' || item.value === 'NO_SALUTATION'
                  : item.value === 'MR' ||
                    item.value === 'MRS' ||
                    item.value === 'NO_SALUTATION',
              ).map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {availableSources.length > 1 && (
            <Button
              title={`Quelle wechseln: Aktuell ${fieldState.selected}. Verfügbar: ${availableSources.join(', ')}`}
              sx={{
                width: '40px',
                height: '40px',
                minWidth: '40px',
                maxWidth: '40px',
              }}
              onClick={() => handleCycleSource(fieldKey)}
              variant="outlined"
            >
              {getButtonIcon()}
            </Button>
          )}
        </>
      )}
    </Box>
  );
};

export default SalutationField;
